import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const Interlude = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.06, 1]);

  return (
    <section ref={ref} data-testid="interlude-section" className="relative on-dark bg-[#0D1B2A] h-[62vh] md:h-[78vh] overflow-hidden">
      <motion.img
        src="/assets/beef-package.webp"
        alt="Packaged meat with Telltag attached"
        loading="lazy"
        className="absolute max-w-none left-[-30%] w-[160%] top-[-6%] md:left-[18%] md:w-[76%] md:top-[-18%]"
        style={{ y, scale }}
        data-testid="interlude-package"
      />
      <span className="absolute left-6 md:left-10 bottom-6 md:bottom-8 mono text-xs tracking-[0.2em] text-[#F2F3F5]/70" data-testid="interlude-caption">
        MEAT / POULTRY
      </span>
    </section>
  );
};
